/* Presentation only: the existing banner form owns prices, files, and checkout. */
(() => {
  function mount(root) {
    if (root.dataset.studioReady) return;
    root.dataset.studioReady = 'true';
    const form = root.querySelector('[data-banner-form]');
    const choices = root.querySelector('[data-bbs-active]');
    const next = root.querySelector('[data-bbs-next]');
    const submit = root.querySelector('.bb__submit');
    const mobile = matchMedia('(max-width:1099px)');
    const stage = root.querySelector('.bb__preview-stage');
    const wrap = root.querySelector('.bbs-banner-wrap');
    const width = root.querySelector('[data-width]');
    const height = root.querySelector('[data-height]');
    const tabs = [...root.querySelectorAll('[data-bbs-tab]')];
    const reducedMotion = matchMedia('(prefers-reduced-motion:reduce)');
    const scrollToChoices = () => choices.scrollIntoView({behavior:reducedMotion.matches ? 'auto' : 'smooth', block:'start'});
    const setPanel = (panel, scroll = false) => {
      choices.dataset.bbsActive = panel;
      tabs.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.bbsTab === panel)));
      next.hidden = !mobile.matches || panel === 'order';
      submit.hidden = mobile.matches && panel !== 'order';
      next.textContent = panel === 'material' ? 'Size & finishing →' : 'Add artwork →';
      if (scroll && mobile.matches) {
        // Keep the selected step and its controls together after a short panel replaces a long one.
        tabs.find(button => button.dataset.bbsTab === panel)?.focus({preventScroll:true});
        requestAnimationFrame(scrollToChoices);
      }
    };
    tabs.forEach(button => button.addEventListener('click', () => setPanel(button.dataset.bbsTab, true)));
    next.addEventListener('click', () => {
      if (choices.dataset.bbsActive === 'size') {
        for (const input of [width, height]) if (!input.checkValidity()) { input.reportValidity(); return; }
      }
      setPanel(choices.dataset.bbsActive === 'material' ? 'size' : 'order', true);
    });
    // Reveal native validation targets before the browser attempts to focus them.
    let validationFrame = false;
    form.addEventListener('invalid', event => {
      if (validationFrame) return;
      validationFrame = true;
      setPanel(event.target.closest('[data-bbs-panel]')?.dataset.bbsPanel || 'order');
      requestAnimationFrame(() => { validationFrame = false; });
    }, true);
    const revealArtwork = event => {
      if (event.type === 'keydown' && !['Enter', ' '].includes(event.key)) return;
      if (event.target.closest('[data-preview-canvas]')) setPanel('order');
    };
    // Capture on the form before the Pro Vault adapter handles the canvas itself.
    form.addEventListener('click', revealArtwork, true);
    form.addEventListener('keydown', revealArtwork, true);
    root.querySelectorAll('[data-bbs-source]').forEach(button => button.addEventListener('click', () => {
      setPanel('order');
      const picker = root.querySelector('[data-fp-vault-anchor] [data-fp-pro-vault-picker]');
      if (picker) {
        const summary = picker.querySelector('[data-fp-vault-selected-summary]');
        if (summary && !summary.hidden) picker.querySelector('[data-fp-vault-change]')?.click();
        picker.querySelector(`[data-fp-vault-source="${button.dataset.bbsSource}"]`)?.click();
        picker.scrollIntoView({behavior:reducedMotion.matches ? 'auto' : 'smooth',block:'center'});
      } else root.querySelector('[data-preview-canvas]')?.click();
    }));
    function sync() {
      const material = root.querySelector('.bb__materials input:checked');
      const w = Math.max(.5, Number(width.value) || .5);
      const h = Math.max(.5, Number(height.value) || .5);
      root.dataset.bbsMaterial = material?.value === 'Mesh Banner' ? 'mesh' : 'vinyl';
      root.querySelectorAll('[data-bbs-guide]').forEach(guide => {
        guide.hidden = guide.dataset.bbsGuide !== root.dataset.bbsMaterial;
      });
      root.querySelector('[data-bbs-material]').textContent = material?.value || 'Banner';
      root.querySelector('[data-bbs-summary]').textContent = `${material?.value || 'Banner'} · ${w} × ${h} ft`;
      const stageStyle = getComputedStyle(stage);
      const availableW = stage.clientWidth - parseFloat(stageStyle.paddingLeft) - parseFloat(stageStyle.paddingRight);
      const availableH = stage.clientHeight - parseFloat(stageStyle.paddingTop) - parseFloat(stageStyle.paddingBottom);
      if (availableW > 0 && availableH > 0) wrap.style.width = `${Math.max(1, Math.min(availableW, availableH * w / h))}px`;
    }
    form.addEventListener('input', sync);
    form.addEventListener('change', sync);
    root.querySelectorAll('[data-size-width]').forEach(button => button.addEventListener('click', sync));
    new ResizeObserver(sync).observe(stage);
    mobile.addEventListener('change', () => { setPanel(choices.dataset.bbsActive || 'material'); sync(); });
    setPanel('material');
    sync();
  }
  document.querySelectorAll('.bbs[data-fp-banner-builder]').forEach(mount);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.bbs[data-fp-banner-builder]').forEach(mount));
})();
